import React, { useState } from "react";
import "./DefaultTextInput.styles.scss";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const DefaultTextInput = ({
  name,
  label,
  value,
  onChange,
  containerClassNames,
  labelClassNames,
  inputClassNames,
  type = "text",
  disabled,
  copyIcon,
  copyToClipboard,
}: {
  name: string;
  label: string;
  value: string | null;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  containerClassNames: string;
  labelClassNames: string;
  inputClassNames: string;
  type?: string;
  disabled?: boolean;
  copyIcon?: any;
  copyToClipboard?: (text: string, name: string) => Promise<void>;
} & Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "value"
>) => {
  const [inputType, setInputType] = useState(type);
  const inputValue = value ?? "";

  const toggleInputType = () => {
    setInputType((currentType) =>
      currentType === "text" ? "password" : "text"
    );
  };

  return (
    <div className={containerClassNames}>
      <p className={`${labelClassNames} pulse-default-text-input-label`}>
        {label}
        {copyIcon && copyToClipboard && (
          <div
            className="pulse-color--background-50 pulse-ml-1 pulse-default-text-input-copy-icon"
            onClick={() => copyToClipboard(inputValue, label)}
          >
            {copyIcon}
          </div>
        )}
      </p>
      <div className="input-icon-container">
        <input
          className={`input-field ${inputClassNames}`}
          name={name}
          value={inputValue}
          onChange={(e) => onChange(e)}
          type={inputType}
          disabled={disabled}
          style={{ color: `${disabled ? "#627195" : "#e8eaef"}` }}
        />
        {type === "password" && (
          <div
            className="password-toggle"
            onClick={() => {
              toggleInputType();
            }}
          >
            {inputType === "password" ? (
              <VisibilityIcon fontSize="small" />
            ) : (
              <VisibilityOffIcon fontSize="small" />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DefaultTextInput;
